import { useParams } from "react-router-dom";
import Loading from "../../Loading";
import useDB from "../../hooks/useDB";
import Error from "../../components/Error";
import ClassOverview from "./ClassOverview";
import ClassSchedule from "./ClassSchedule";
import ClassNotes from "./ClassNotes";
import ClassSettings from "./ClassSettings";
import StudentData from "./StudentData";

/**
 * HtClass Component
 * Main class page with horizontal info cards row and 2-column student layout.
 * Uses Tailwind for all styles with flat design system.
 *
 * @component
 * @author Forge
 * @date 2026-04-10
 * @version 4.0.0
 */
export default function HtClass() {
  let { id, classType, unitId, lessonId } = useParams();
  const [htClass, setHtClass, error, loading] = useDB(`/class/${id}`);

  if (loading) return <Loading />;
  if (error) return <Error />;

  return (
    <div className="p-6 max-w-full min-h-screen bg-slate-50 text-slate-900">
      {/* Top Row: Info Cards */}
      <div className="flex flex-wrap gap-4 mb-6">
        <ClassOverview htClass={htClass} setHtClass={setHtClass} />
        <ClassSchedule htClass={htClass} />
        <ClassNotes htClass={htClass} setHtClass={setHtClass} />
        <ClassSettings
          htClass={htClass}
          setHtClass={setHtClass}
          classType={classType}
          unitId={unitId}
          lessonId={lessonId}
        />
      </div>

      {/* Student Section: 2-column grid */}
      <div className="grid grid-cols-[320px_1fr] gap-6 items-start">
        <StudentData
          htClass={htClass}
          setHtClass={setHtClass}
        />
      </div>
    </div>
  );
}